/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../config-provider';
import nextLocale from '../locale/zh-cn';
import Balloon from './balloon';
import Icon from '../icon';
import Button from '../button';

const iconMap = {
  info: 'info-o-fill',
  success: 'info-o-fill',
  warning: 'warning-o-fill',
  danger: 'remove-o-fill',
};

const noop = () => {};

class PopConfirm extends React.Component {
  static displayName = 'PopConfirm';

  static propTypes = {
    prefix: PropTypes.string,
    locale: PropTypes.object,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    type: PropTypes.oneOf(['info', 'warning', 'success', 'danger']),
    align: Balloon.propTypes.align,
    alignEdge: PropTypes.bool,
    icon: PropTypes.node,
    title: PropTypes.node,
    content: PropTypes.node,
    footer: PropTypes.bool,
    confirmProps: PropTypes.object,
    cancelProps: PropTypes.object,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    defaultVisible: PropTypes.bool,
    visible: PropTypes.bool,
    onVisibleChange: PropTypes.func,
    offset: PropTypes.array,
    trigger: PropTypes.node.isRequired,
    triggerType: PropTypes.oneOf(['hover', 'click']),
    needAdjust: PropTypes.bool,
    shouldUpdatePosition: PropTypes.bool,
    safeNode: PropTypes.string,
    safeId: PropTypes.string,
    animation: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    cache: PropTypes.bool,
    popupContainer: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    popupStyle: PropTypes.object,
    popupClassName: PropTypes.string,
    popupProps: PropTypes.object,
    followTrigger: PropTypes.bool,
    id: PropTypes.string,
  };

  static defaultProps = {
    prefix: 'next-',
    size: 'medium',
    locale: nextLocale.Balloon,
    type: 'info',
    align: 'b',
    alignEdge: true,
    footer: true,
    confirmProps: {},
    cancelProps: {},
    onConfirm: noop,
    onCancel: noop,
    defaultVisible: false,
    onVisibleChange: noop,
    offset: [0, 0],
    triggerType: 'hover',
    needAdjust: true,
    animation: { in: 'zoomIn', out: 'zoomOut' },
    cache: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible || props.defaultVisible,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.visible !== this.props.visible) {
      this.setState({
        visible: nextProps.visible,
      });
    }
  }

  onVisibleChange = visible => {
    if (!('visible' in this.props)) {
      this.setState({
        visible,
      });
    }
    this.props.onVisibleChange(visible);
  };

  renderIcon = () => {
    const { type, icon } = this.props;
    return (
      <div
        className={cls({ 'pop-confirm-icon-area': true, [`pop-confirm-icon-area-${type}`]: type })}
      >
        {icon || <Icon type={iconMap[type] || iconMap.info} />}
      </div>
    );
  };

  renderTitleAndContent = () => {
    const { title, content, footer } = this.props;
    return (
      <div
        className={cls({
          'title-content-area': true,
          'title-content-area-no-footer': !footer,
        })}
      >
        {title ? <div className="title-area">{title}</div> : null}
        {
          <div
            className={cls({
              'content-area': true,
              'content-area-no-title': !title,
            })}
          >
            {content}
          </div>
        }
      </div>
    );
  };

  renderFooter = () => {
    const { type, locale, footer, confirmProps, cancelProps, onConfirm, onCancel } = this.props;
    return footer ? (
      <div className="footer-area">
        <Button {...cancelProps} onClick={onCancel} type="normal" size="small">
          {locale.cancel}
        </Button>
        <Button {...confirmProps} onClick={onConfirm} type="primary" warning={type === 'danger'} size="small">
          {locale.confirm}
        </Button>
      </div>
    ) : null;
  };

  render() {
    const {
      prefix,
      size,
      trigger,
      align,
      alignEdge,
      offset,
      triggerType,
      needAdjust,
      shouldUpdatePosition,
      safeNode,
      safeId,
      animation,
      cache,
      popupContainer,
      popupStyle,
      popupClassName,
      popupProps,
      followTrigger,
      id,
    } = this.props;
    const { visible } = this.state;
    return (
      <Balloon
        autoFocus={false}
        closable={false}
        popupClassName={cls(
          {
            [`${prefix}pop-confirm`]: true,
            [`${prefix}pop-confirm-${size}`]: true,
          },
          popupClassName,
        )}
        prefix={prefix}
        visible={visible}
        onVisibleChange={this.onVisibleChange}
        align={align}
        alignEdge={alignEdge}
        offset={offset}
        trigger={trigger}
        triggerType={triggerType}
        needAdjust={needAdjust}
        shouldUpdatePosition={shouldUpdatePosition}
        safeNode={safeNode}
        safeId={safeId}
        animation={animation}
        cache={cache}
        popupContainer={popupContainer}
        popupStyle={popupStyle}
        popupProps={popupProps}
        followTrigger={followTrigger}
        id={id}
      >
        <div className={`${prefix}pop-confirm-container`}>
          {this.renderIcon()}
          {this.renderTitleAndContent()}
          {this.renderFooter()}
        </div>
      </Balloon>
    );
  }
}

export default ConfigProvider.config(PopConfirm);
